// @ts-nocheck

import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { fetchMenuAccessItems, addMenuAccessItem, updateMenuAccessItem } from "../../api/menuAccessApi";

// Async thunks for menuAccess operations

export const getMenuAccessItems = createAsyncThunk(
  "menuAccess/getMenuAccessItems",
  async (_, { dispatch, rejectWithValue }) => {
    dispatch(resetStatus());

    try {
      return await fetchMenuAccessItems();
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const createMenuAccessItem = createAsyncThunk(
  "menuAccess/createMenuAccessItem",
  async (newMenuAccessItem: { name: string; description: string; is_active: boolean; permissions?: string[] }, { dispatch, rejectWithValue }) => {
    dispatch(resetStatus());

    try {
      return await addMenuAccessItem(newMenuAccessItem);
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const editMenuAccessItem = createAsyncThunk(
  "menuAccess/editMenuAccessItem",
  async (
    { updatedMenuAccessItem }: { updatedMenuAccessItem: { id: string; name: string; description: string; is_active: boolean; permissions?: string[] } },
    { dispatch, rejectWithValue }
  ) => {
    dispatch(resetStatus());

    try {
      return await updateMenuAccessItem(updatedMenuAccessItem);
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

// MenuAccess Slice

const menuAccessSlice = createSlice({
  name: "menuAccess",
  initialState: {
    menuAccessItems: [] as any[],  // Store menu access items
    status: null as boolean | null, // Loading status
    msg: "",
    error: null as string | null,
  },
  reducers: {
    resetStatus(state) {
      state.status = null;
      state.msg = "";
    },
  },
  extraReducers: (builder) => {
    builder
      // Get all menu access items
      .addCase(getMenuAccessItems.fulfilled, (state, action: PayloadAction<any[]>) => {
        state.status = true;
        state.menuAccessItems = action.payload;
      })
      .addCase(getMenuAccessItems.rejected, (state, action) => {
        state.status = false;
        state.error = action.payload as string;
      })

      // Create menu access item
      .addCase(createMenuAccessItem.fulfilled, (state, action: PayloadAction<any>) => {
        if (Array.isArray(state.menuAccessItems)) {
          state.menuAccessItems.push(action.payload);
          state.status = true;
          state.msg = "Menu access item created successfully.";
        } else {
          console.log("menuAccessItems not an array");
        }
      })
      .addCase(createMenuAccessItem.rejected, (state, action) => {
        state.status = false;
        state.error = action.payload as string;
      })

      // Edit menu access item
      .addCase(editMenuAccessItem.fulfilled, (state, action: PayloadAction<any>) => {
        const { id, data } = action.payload;
        if (Array.isArray(state.menuAccessItems)) {
          const index = state.menuAccessItems.findIndex((item) => item.id === id);
          if (index !== -1) {
            state.menuAccessItems[index] = data;
          }
          state.status = true;
          state.msg = "Menu access item updated successfully.";
        } else {
          console.log("menuAccessItems not an array");
        }
      })
      .addCase(editMenuAccessItem.rejected, (state, action) => {
        state.status = false;
        state.error = action.payload as string;
      });
  },
});

export const { resetStatus } = menuAccessSlice.actions;
export default menuAccessSlice.reducer;
